import { CartDto } from '@mkp/publication/models';
import { formatPrice } from '@mkp/shared/util-product';
import { PromotionCategory } from '@mkp/tracking/models';

export const getPromotionCategory = ({
  orderPromotionTotal,
  taxExcludedTotal,
  promotionCoupon,
}: CartDto): PromotionCategory => {
  const round2Digit = (num: number) => Math.abs(num).toFixed(2);

  // we support only one coupon per Cart
  // promotion represents the total discount for complete Cart, not available per item
  // only add prop if it exists (causes issue on tealium)
  return Object.assign(
    {},
    orderPromotionTotal
      ? {
          promotion_discount_chf: [Number(round2Digit(formatPrice(orderPromotionTotal)))],
          promotion_discount_percent: [
            `${round2Digit((orderPromotionTotal / (taxExcludedTotal + Math.abs(orderPromotionTotal))) * 100)}`,
          ],
        }
      : null,
    promotionCoupon ? { promotion_voucher_ID: [promotionCoupon.code] } : null
  );
};
